import { createBrowserRouter, Navigate } from 'react-router-dom';
import { RequireAuth } from '@/components/layout/RequireAuth';
import { RoleGate } from '@/components/layout/RoleGate';
import { RequireDeviceBound } from '@/components/layout/RequireDeviceBound';
import { RequireOpenShift } from '@/components/layout/RequireOpenShift';
import { AppShell } from '@/components/pos/AppShell';
import { LoginPage } from '@/pages/LoginPage';
import { DeviceSetupPage } from '@/pages/DeviceSetupPage';
import { MenuPage } from '@/pages/MenuPage';
import { SellPage } from '@/pages/SellPage';
import { FocSellPage } from '@/pages/FocSellPage';
import { FocDocumentPage } from '@/pages/FocDocumentPage';
import { DetailsPage } from '@/pages/DetailsPage';
import { CheckoutPage } from '@/pages/CheckoutPage';
import { OrderLookupPage } from '@/pages/OrderLookupPage';
import { PrintTicketPage } from '@/pages/PrintTicketPage';
import { ManageAddonsPage } from '@/pages/ManageAddonsPage';
import { ShiftSummaryPage } from '@/pages/ShiftSummaryPage';
import { CloseShiftPage } from '@/pages/CloseShiftPage';
import { EdcPreviewPage } from '@/pages/EdcPreviewPage';
import { RequestsPage } from '@/pages/RequestsPage';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  // DEV-only: review the EDC panel's phases without a terminal. Vite strips
  // this from a production build.
  ...(import.meta.env.DEV
    ? [{ path: '/__edc-preview', element: <EdcPreviewPage /> }]
    : []),
  {
    element: <RequireAuth />,
    children: [
      {
        element: <RoleGate />,
        children: [
          {
            // A cashier opens a shift before anything else (the server refuses their sales without one).
            element: <RequireOpenShift />,
            children: [
              {
                element: <AppShell />,
                children: [
                  // Device-bound surfaces
                  {
                    element: <RequireDeviceBound />,
                    children: [
                      { index: true, element: <SellPage /> },
                      // Free-of-charge flow: FOC catalog → supporting document →
                      // the shared Details + Checkout steps.
                      { path: 'foc', element: <FocSellPage /> },
                      { path: 'foc/document', element: <FocDocumentPage /> },
                      { path: 'details', element: <DetailsPage /> },
                      { path: 'checkout', element: <CheckoutPage /> },
                    ],
                  },
                  // Reachable without a bound printer
                  { path: 'menu', element: <MenuPage /> },
                  { path: 'orders', element: <OrderLookupPage /> },
                  // The operator's own void / refund requests (supervisor approves in the BO).
                  { path: 'requests', element: <RequestsPage /> },
                  { path: 'print-ticket', element: <PrintTicketPage /> },
                  { path: 'manage-addons', element: <ManageAddonsPage /> },
                  { path: 'shift', element: <ShiftSummaryPage /> },
                  // Only the drawer count + close (Beranda's "Tutup shift").
                  { path: 'shift/close', element: <CloseShiftPage /> },
                ],
              },
            ],
          },
          // First-run binding lives outside the AppShell (no rail distractions)
          { path: 'setup', element: <DeviceSetupPage /> },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
